<template>
  <div class="home_intro">
      <div class='intro'>
          <!-- <h2 v-html="intro.title"></h2> -->
          <!-- <img :src='intro.img'/> -->
            <p v-html="intro.cont"></p>
          <img class="fig" :src="fig_src">
      </div>
      <div class='news'>
          <Doc :paras="news_paras" class="news_doc"></Doc>
      </div>
  </div>
</template>

<script>
// import pmglab_logo from '@/assets/img/pmglab_logo_rev.png';
// import sysu_logo from '@/assets/img/sysu_logo.png';
// import intro_fig from '@/assets/img/intro_fig.png';
import fig1 from '@/assets/img/errorcom.png';
import Doc from '@/components/doc.vue'
export default {
  components: {Doc},
  name: 'home_intro',
  data:function(){
        return {
            intro:{
                title:'KGGSEE: A biological <span style="color: red">K</span>nowledge-based mining platform for <span style="color: red">G</span>enomic and\
                 <span style="color: red">G</span>enetic association <span style="color: red">S</span>ummary statistics using g<span style="color: red">E</span>ne \
                 <span style="color: red">E</span>xpression',
                // img:intro_fig,
                cont:'The Genetic Type I error calculator (GEC) is a Java-based application developed to address multiple-testing issue with dependent Single-nucleotide polymorphisms (SNPs). The core part is a new measure of effective number of independent tests Me , which is more robust than available methods [See the figure below]. Based on this new measure, several popular multiple-testing methods including Bonferroni, Holm, Simes correction was improved to evaluate significance level of SNP p-values in genome-wide association studies. A standalone version of this tool was provided to process large datasets on users’ local computers and an \
                  <a href="./#/online" style="color:#316652">ONLINE version</a>\
                  was made for users to quick handle a SMALL dataset conveniently.'
            },
            fig_src:fig1,
            function_des:[
                {
                    name:'Browse',
                    des:'Browse the association landscape between phenotypes and single cell clusters.',
                    url:'browse',
                    class:'f1'
                },{
                    name:'Customized Analysis',
                    des:'Cross annotatation for customized phenotypes and single cell clusters.',
                    url:'analyze',
                    class:'f2'
                }
            ],
            news_paras:{
                has_outline:false, 
                msg:{
                    'Updates and News':
                        ['<span style="font-weight:bold;">2022-11-03</span>: Fixed and optimized online tool.\
                        ',
                        '<span style="font-weight:bold;">2021-02-02</span>: The GEC method has been implemented in <a href="http://pmglab.top/kggsee">KGGSEE</a> software tool. And we provide a \
                        new <a href="./#/online" style="color:#316652">web server</a> for online analysis. \
                        '
                    ]
                    ,
                    'Citations':
                        ['Li MX, Yeung JM, Cherny SS, Sham PC. Evaluating the effective numbers of independent tests and significant p-value thresholds in commercial genotyping arrays and public imputation reference datasets. Hum Genet. 2012 May;131(5):747-56.'],
                    'Contact us':[
                        "We'd love to hear from you!\
                        To provide feedback or ask a question, contact us on <a href='mailto:limx54@163.com'>limx54@163.com</a>.\
                        "
                    ]
                    ,
                }
            }
        }
    },
    methods:{
        url_go:function(url){
            this.$router.push({path:'/'+url});
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home_intro{
    width: 1000px;
    /* margin: 20px auto; */
    margin: 0;
}

.intro,.news{
    padding: 2px;
    width: 960px;
    /* background: rgb(240, 241, 241); */
    margin: 10px auto;
    border: solid #E1EAEA 1px;
    }

.intro {
    height:500px;

    /* margin: 40px 0; */
}


.intro p {

    /* text-align: left; */
    line-height: 18px;
    margin: 20px 30px 10px 30px;
    width: 880px;
    margin-right: 50px;
    /* float:left; */
}


.fig{
    /* float:left; */
    /* display: inline; */
    width:460px;
    margin: 20px 200px;
}

.news_doc{
    margin:0px 30px;
}

p {
    color: #000000;
    line-height: 15px;
    font-size: 15px;
    margin:5px 0px;
}

h2{
    font-size: 20px;
    line-height: 20px;
    margin:15px 0px;
}


</style>



// WEBPACK FOOTER //
// src/components/home_intro.vue